import { teamId, type TeamId } from './teams'

export interface MockFriend {
  userId: string
  name: string
  /** Canonical team id. */
  favouriteTeam: TeamId
  basePoints: number
}

interface RawMockFriend extends Omit<MockFriend, 'favouriteTeam'> {
  favouriteTeam: string
}

/**
 * 10 permanent fabricated friends, auto-added to every player's friends list and to the
 * Global League standings. Fixed ids/names/teams so they read the same way run to run.
 */
const rawMockFriends: RawMockFriend[] = [
  { userId: 'friend-01', name: 'Jamal Whitfield', favouriteTeam: 'Liverpool', basePoints: 388 },
  { userId: 'friend-02', name: 'Elena Voss', favouriteTeam: 'Man City', basePoints: 355 },
  { userId: 'friend-03', name: 'Kwame Asante', favouriteTeam: 'Chelsea', basePoints: 330 },
  { userId: 'friend-04', name: 'Lucia Fernandez', favouriteTeam: 'Arsenal', basePoints: 298 },
  { userId: 'friend-05', name: 'Ravi Malhotra', favouriteTeam: 'Newcastle', basePoints: 271 },
  { userId: 'friend-06', name: 'Freya Lindqvist', favouriteTeam: 'Tottenham', basePoints: 240 },
  { userId: 'friend-07', name: 'Diego Alvarez', favouriteTeam: 'Aston Villa', basePoints: 205 },
  { userId: 'friend-08', name: 'Aisha Bakr', favouriteTeam: 'Brighton', basePoints: 176 },
  { userId: 'friend-09', name: 'Noah Kim', favouriteTeam: 'Hull City', basePoints: 142 },
  { userId: 'friend-10', name: 'Sofia Marchetti', favouriteTeam: 'Crystal Palace', basePoints: 108 },
]

export const mockFriends: MockFriend[] = rawMockFriends.map((friend) => ({
  ...friend,
  favouriteTeam: teamId(friend.favouriteTeam),
}))
